import { TOURIST_SOURCE_DATA, TOURIST_SOURCE_DATA_SUCCESS, TOURIST_SOURCE_DATA_ERROR } from './actionTypes'

export function touristSourceData(successCallback, errorCallback) { return { type: TOURIST_SOURCE_DATA, successCallback, errorCallback }}
export function touristSourceDataSuccess(data, successCallback) { return { type: TOURIST_SOURCE_DATA_SUCCESS, data, successCallback }}
export function touristSourceDataError(error, errorCallback) { return { type: TOURIST_SOURCE_DATA_ERROR, error, errorCallback }}


// WEBPACK FOOTER //
// ./src/actions/touristSourceData.js